export type Brand = {
  id: string;
  logoUrl?: string;
  logoAlt?: string;
  primaryColor?: string;
  primaryForeground?: string;
  backgroundColor?: string;
  backgroundForeground?: string;
  radius?: string;
  fontDisplay?: string;
  fontBody?: string;
};

export const DEFAULT_BRAND: Brand = {
  id: "default",
  logoAlt: "Brand",
};
